import { Helmet } from 'react-helmet';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {
  Modal,
  Button,
  Spinner,
} from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import axiosCore from '../../common/axiosCore';
import useAuth from '../../hooks/useAuth';
import { customTotal, pageButtonRenderer } from '../../common/constants';
import UserCard from '../../components/userCard';
import profile from '../profile.svg';
import { logout } from '../../services/MockAuthService';
import IdleTimer from '../../services/idleTimer';
import AlertTimeout from '../../components/alertTimeout';

function MemberCard() {
  const title = 'Member Card';
  const [OffId, setOffId] = useState();
  const [OfficeName, setOfficeName] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setIsWaiting] = useState(true);
  const [base64URL, setBase64URL] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [catchError, setIsCatchError] = useState('');
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);
  const [offices, setOffices] = useState([]);
  const [show, setShow] = useState(false);

  const [selectedFile, setSelectedFile] = useState('');
  const [isFilePicked, setIsFilePicked] = useState(false);

  const [duplicateCards, setDuplicateCards] = useState([]);
  const { getSession } = useAuth();
  const { getProfileAvatar } = useAuth();
  const { getDoj } = useAuth();
  const { getSignature } = useAuth();
  const { getMemberProfile } = useAuth();
  const navigate = useNavigate();
  const doj = getDoj();
  const signature = getSignature();
  const user = getSession();
  const aI = getProfileAvatar();
  const member = getMemberProfile();

  const [isTimeout, setIsTimeout] = useState(false);
  const handleLogout = async () => {
    await logout();
    navigate('/');
    setIsTimeout(true);
  };
  useEffect(() => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, []);

  const duplicateCardRequest = () => {
    setTimeout(() => {
      axiosCore.post('/member-module/member-card/duplicate-request', {
        MemberId: member.MemberId,
      }).then((result) => {
        if (result.data.status !== 0) {
          setIsWaiting(false);
          setDuplicateCards(result.data.data);
        }
        if (result.data.status === 0) {
          setIsWaiting(false);
          setDuplicateCards(result.data.data);
        }
      }).catch((err) => {
        setIsCatchError(err.message);
        setIsError(true);
      });
    }, 2000);
  };

  useEffect(() => {
    duplicateCardRequest();
    const interval = setInterval(() => {
      duplicateCardRequest();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const loadOffice = () => {
      axiosCore.get('/nssf-office/index').then((response) => {
        const json = response.data.feedback;
        // const json = response.data.data;
        const office = json.map((i) => ({
          label: i.OFFICE_NAME,
          value: i.OFFICE_ID,
        }));
        setOffices(office);
      });
    };
    loadOffice();
    setIsValid(!!OffId);
  }, [OffId]);

  const handleSelectOffice = (e) => {
    setOffId(e.value);
    setOfficeName(e.label);
  };

  const columns = [
    {
      dataField: 'BILLGENDT',
      text: 'Date',
    },
    {
      dataField: 'CONTRNUM',
      text: 'Control No',
    },
    {
      dataField: 'BILLAMT',
      text: 'Amount',
    },
    {
      dataField: 'PAYMENT_STATUS',
      text: 'Payment',
    },

    {
      dataField: 'PRINT_STATUS',
      text: 'Print',
    },
    {
      dataField: 'OFFICE_NAME',
      text: 'Office',
    }];

  const duplicateCardLoad = () => {
    if (duplicateCards.length > 0) {
      return <span>
        <div className="table-responsive">
        <BootstrapTable
          bootstrap4
          keyField='ID'
          data={ duplicateCards }
          columns={ columns }
          pagination={ paginationFactory(options) }
          striped
          hover
          condensed
        />
      </div>
      </span>;
    }
    return <span>
      {!isWaiting && <p className="text-center">No duplicate cards requests</p>}
    </span>;
  };

  const options = {
    pageButtonRenderer,
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [{
      text: '5', value: 5,
    }, {
      text: '10', value: 10,
    }, {
      text: 'All', value: duplicateCards.length,
    }], // A numeric array is also available. the purpose of above example is custom the text
  };

  const handleClose = () => {
    setShow(false);
    setIsFilePicked(false);
    setIsValid(false);
  };
  const handleShow = () => setShow(true);

  const changeHandler = (event) => {
    event.preventDefault();
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const getBase64 = (f) => {
    console.log(f);
    let baseURL = '';
    const reader = new FileReader();
    reader.readAsDataURL(f);
    reader.onload = () => {
      baseURL = reader.result;
      setBase64URL(baseURL);
    };
  };

  const handleDuplicateCard = () => {
    if (!isFilePicked) {
      setIsCatchError('Attach Police Loss Report');
      setIsError(true);
      return;
    }
    if (selectedFile.type !== 'application/pdf') {
      setIsCatchError('Attach PDF File');
      setIsError(true);
      return;
    }
    if (selectedFile.size > 2000000) {
      setIsCatchError('Max file size 2MB');
      setIsError(true);
      return;
    }
    if (OffId) {
      setIsLoading(true);
      getBase64(selectedFile);
      setTimeout(() => {
        axiosCore.post('/member-module/member-card/bill-duplicate-card', {
          MemberId: member.MemberId,
          OfficeId: OffId,
          LossReport: base64URL,
        }).then((result) => {
          if (result.data.status === 1) {
            setIsWaiting(true);
            setIsLoading(false);
            setShow(false);
            setIsAlert(true);
          }
          if (result.data.status === 0) {
            setIsWaiting(true);
            setIsLoading(false);
            setShow(false);
            setIsCatchError(result.data.message);
            setIsError(true);
          }
        }).catch((err) => {
          setIsWaiting(true);
          setIsLoading(false);
          setShow(false);
          setIsCatchError(err.message);
          setIsError(true);
        });
      }, 2000);
    }
  };

  const onConfirm = () => {
    setIsLoading(false);
    setIsAlert(false);
    setIsError(false);
    setIsWaiting(false);
  };

  const onCancel = () => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
        setIsTimeout(true);
      },
    });
    setIsTimeout(false);
    return () => {
      timer.cleanUp();
    };
  };

  if (user) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/console/dashboard">Dashboard</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <div className="row">
            <div className="col">
              <h1 className="page-title">{title}</h1>
            </div>
            <div className="col">
              <button type="button" className="btn btn-claim mb-3" onClick={handleShow}>
                <FaPlus/> Request Duplicate Card
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 rounded">
              <UserCard/>
            </div>
            <div className="col-lg-8 rounded">
              <div className="card">
                <h6 className="card-header d-flex justify-content-between align-items-center">
                  Duplicate Cards
                </h6>
                <div className="card-body m-0">
                  {isWaiting && <p className="text-center">
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      hidden={!isWaiting}/> Please wait...</p>}
                  <div className="table-responsive">
                    {duplicateCardLoad()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {isAlert
        && <SweetAlert
          success
          title="Success Data!"
          onConfirm={onConfirm}
          timeout={2000}
        >
          This success message will automatically close after 2 seconds
        </SweetAlert>
        }
        {isError
        && <SweetAlert
          warning
          title= {catchError}
          onConfirm={onConfirm}
          timeout={10000}
        >
        </SweetAlert>}
        <Modal show={show}
               onHide={handleClose}
               backdrop="static"
               keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title>Duplicate Card</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className='d-flex justify-content-center mb-3'>
                <div className='card-holder'>
                  <div className='card-section'>
                    <div className='logo_photo'>
                      <div className='logo'/>
                      <div className='photo'>
                        {aI ? <img src={`data:image/png;base64,${aI}`} alt="avatar"
                                   className="member_photo"/>
                          : <img src={ profile } alt="avatar"
                                 className="member_photo"/>
                        }
                      </div>
                    </div>
                    <div className="details">
                      <div className="top"/>
                      <div className="nssf_no">
                        <span className="text1">{member.MemberId}</span>
                      </div>
                      <div className="joining_date">
                        <span className="text2">{doj}</span>
                      </div>
                      <div className="member_name">
                        <span className="text3">
                          {member.FirstName} {member.MiddleName}<br/>
                          {member.SurName}
                        </span>
                      </div>
                      <div className="member_signature">
                        < span className="text4">
                          {signature ? <img src={`data:image/png;base64,${signature}`} alt="avatar"
                                     className="signature_img"/>
                            : ''
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label className='mb-2'>Select Pickup Office</label>
                <Select
                  className='mb-3'
                  onChange={handleSelectOffice.bind(this)}
                  placeholder={'type something ...'}
                  options={offices}
                />
              </div>
              <div className="form-group">
                <label className='mb-2'>Upload Police Loss Report</label>
                <div className='mb-2'>
                  <input type="file" onChange={changeHandler} accept="application/pdf" />
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn btn-light' onClick={handleClose}>
              Close
            </Button>
            <Button disabled={!isValid} className='btn btn-green' onClick={handleDuplicateCard}>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                hidden={!isLoading}/> Request Control Number
            </Button>
          </Modal.Footer>
        </Modal>
        {isTimeout
        && <AlertTimeout onConfirm={handleLogout} onCancel={onCancel}/>
        }
      </>
    );
  }
  navigate('/login');
}
export default MemberCard;
